import SampleSavedSearchesReducer from './SampleSavedSearchesReducer';
import { AdminSavedSearchesReducers } from './containers/AdminSavedSearches';

export default from './SampleSavedSearchesContainer';
export const SampleSavedSearchesReducers = {
  SampleSavedSearchesReducer,
  ...AdminSavedSearchesReducers,
};
